// usage in a React component
import { useState } from "react";
import Inline from "../Inline";
import { Button } from "devextreme-react";
import FontAwesomeIcon from "./FontAwesomeIcon";

export default function ScanButton({ subPath, nameOnServer, scanServerUrl }) {
    const [state, setState] = useState({});

    async function handleScan() {
        setState({
            ...state,
            showLink: false,
            errorMessage: '',
            status: <FontAwesomeIcon icon='spinner' spin fontSize='2rem' />, //'درحال اسکن...',
            imgBlob: null
        });

        try {
            const scannerUrl = `${scanServerUrl}/scan`;
            const uploadUrl = `${window.config.API_PREFIX}/api/file/upload?subPath=${subPath ?? ''}&nameOnServer=${nameOnServer ?? '[same]'}`;

            const res = await fetch(scannerUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'logonkey': window.user?.logonkey
                },
                body: JSON.stringify({ uploadUrl })
            });

            if (res?.error?.length > 0 || res?.ok != true)
                throw ({ message: res?.error ?? res?.statusText });

            setState({ ...state, imgBlob: await res.blob(), status: 'تصویر آپلود شد ', errorMessage: '', showLink: false });
        } catch (e) {
            setState({ ...state, showLink: true, status: '', errorMessage: 'خطا: ' + e.message });
            console.log('Scan-upload error: ', e);
        }
    }

    const imgUrl = state.imgBlob ? URL.createObjectURL(state.imgBlob) : '';

    return (
        <div>
            <Inline spacing='5px' style={{ alignItems: 'center', width: 'calc(100px + 12rem)' }}>
                <div style={{ padding: '1rem' }}>
                    <Button text='اسکن' width='8rem' icon='import' onClick={handleScan} />
                </div>

                {
                    imgUrl?.length > 0 &&
                    <img src={imgUrl} width='100px' height='auto' alt='' visible={imgUrl?.length > 0} />
                }

                <div style={{ padding: '1rem' }} visible={imgUrl?.length > 0}>
                    {state.status}
                </div>

                {
                    state.showLink &&
                    <a download={true}
                        style={{ fontSize: '0.8rem', textAlign: 'center', minWidth: '4rem', display: 'inline-flex', alignItems: 'center' }}
                        href={`${window.config.API_PREFIX}/api/file/download?filePathName=ware_house%2FScannerServer.zip`}>
                        <FontAwesomeIcon icon='download' fontSize='1.2rem' fade />
                        &nbsp;
                        دانلود سرور اسکن
                    </a>
                }
            </Inline>


            <div style={{ padding: '0 1rem', height: '2rem', color: 'red', visible: state.errorMessage?.length > 0 }}>
                {state.errorMessage}
            </div>

        </div>
    );
}
